"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullscreenHelpers = void 0;
class FullscreenHelpers {
    static async toggleFullscreen(element, isFullscreen) {
        if (!element) {
            return;
        }
        if (isFullscreen) {
            await document.exitFullscreen();
        }
        else {
            await element.requestFullscreen();
        }
    }
}
exports.FullscreenHelpers = FullscreenHelpers;
